import React from 'react';
import get from "lodash/get";
import {AbstractReactFactory} from '@projectstorm/react-canvas-core';

import {AbstractNodeModel, AbstractNodeWidget} from "./AbstractNode";
import {withTranslation} from "react-i18next";


class HTTPRequestNodeWidget_ extends AbstractNodeWidget {
    constructor() {
        super();

        this.type = 'http-request-node';
    }

    getCascadeStepLabel() {
        return this.props.t('pages.main.flow_builder.node.http_request.cascade_step', 'Request failed')
    }
    
    getHeaderClassName() {
        return 'bg-mixed-hopes bg-opacity-3';
    }

    getHeader() {
        const options = this.props.node.options;
        return <>
            <i className="pe-7s-cloud-upload"> </i> {options.step.name || this.props.t('pages.main.flow_builder.node.http_request.name', 'HTTP-request')}
        </>;
    }

    getBody() {
        const options = this.props.node.options;
        const requestConfig = get(options.step, 'state.request_config');

        if (!requestConfig) {
            return '';
        }

        return <>
            <div><strong>{requestConfig.method}</strong> {requestConfig.url}</div>
            <div>{['POST', 'PUT', 'PATCH'].indexOf(requestConfig.method) && requestConfig.body}</div>
        </>;
    }

    getErrors() {
        const options = this.props.node.options;
        const url = get(options.step, 'state.request_config.url');

        const errors = [];
        if (!url) {
            errors.push(this.props.t('pages.main.flow_builder.node.http_request.error.url_is_not_specified', 'Please provide request URL'));
        }

        return errors.map((error, idx) => <div className='py-2' key={idx}>
                <i className='text-danger opacity-9'>{error}</i>
            </div>
        );
    }
}

export const HTTPRequestNodeWidget = withTranslation()(HTTPRequestNodeWidget_);


export class HTTPRequestNodeModel extends AbstractNodeModel {
    constructor(options = {}) {
        super({
            ...options,
            type: 'http-request-node',
            alwaysEnableCascadePort: true,
            disableCascadePort: true,
        });
    }
}


export class HTTPRequestNodeFactory extends AbstractReactFactory {
    constructor() {
        super('http-request-node');
    }

    generateModel(event) {
        return new HTTPRequestNodeModel();
    }

    generateReactWidget(event) {
        return <HTTPRequestNodeWidget engine={this.engine} node={event.model}/>;
    }
}
